/**
 * 「Kumo からのお知らせ」の欄をこのゲームで出すか（config の `kumoNews.optIn`・2026-09-27 creator/news-optout）。KumoNewsCard.tsx が使う。
 *
 * founder 決定（2026-09-27・MASTER-PLAN §1c）: 既定で出し、クリエイターがダッシュボードで外せる。
 * サーバーの正は apps/server/src/modules/mailconsent/newsConfig.ts（既定値の定数 KUMO_NEWS_OPT_IN_DEFAULT = true）。
 * ここは import を持たない純粋な関数だけ（featureToggle.ts と同じ理由: `node --test` で型の除去だけで動かす）。
 * 反映の形は機能の切り替え（FeaturesCard）と同じ: 今の config を取り直す → applyChanges で 1 か所だけ書き換える → PUT …/config。
 */

/** config のパス（ドット区切り）。featureToggle.ts の Change.configPath・CLI の書く場所と同じ */
export const KUMO_NEWS_PATH = 'kumoNews.optIn';
/** 変更の key（CLI で `features on|off kumoNews` と打つ名前 = featureToggle.localFix がこの名前でコマンドを出す） */
export const KUMO_NEWS_KEY = 'kumoNews';

/**
 * サーバーが返した config で、欄が出る設定か。
 * kumoNews が無い = スイッチを持たない古いサーバー（そこでは欄は常に出る）か、既定値のまま → true。
 * WHY 既定をここで true と書くか: サーバーの既定値（KUMO_NEWS_OPT_IN_DEFAULT）を import できない（ダッシュボードは別のパッケージ）。
 *   新しいサーバーは parse 済みの config を返すので、値が無いのは古いサーバーだけ = true が常に正しい
 */
export function kumoNewsOn(config: unknown): boolean {
  const news = config && typeof config === 'object' ? (config as { kumoNews?: unknown }).kumoNews : undefined;
  const v = news && typeof news === 'object' ? (news as { optIn?: unknown }).optIn : undefined;
  return typeof v === 'boolean' ? v : true;
}

/** 欄を出す / 外す変更（featureToggle.ts の Change と同じ形 = applyChanges・localFix にそのまま渡せる） */
export function kumoNewsChange(on: boolean): { key: string; configPath: string; on: boolean } {
  return { key: KUMO_NEWS_KEY, configPath: KUMO_NEWS_PATH, on };
}
